import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { DataService } from '../../shared/services/data.service';
import { Memo, MemoShortName } from '../models/memo.model';

@Injectable({ providedIn: 'root' })
export class MemoService {
  private readonly dataService = inject(DataService);

  private readonly basePath = 'api/memo';

  /** Reads a memo by short name. Requires `read:memo`; 404s when the memo has never been written. */
  public getMemoByShortName(shortName: string | MemoShortName): Observable<Memo> {
    return this.dataService.get<Memo>(`${this.basePath}/${encodeURIComponent(shortName)}`);
  }

  /** Creates or replaces a memo's content. Requires `write:memo`. */
  public upsertMemo(shortName: string | MemoShortName, content: string): Observable<Memo> {
    return this.dataService.put<{ content: string }, Memo>(`${this.basePath}/${encodeURIComponent(shortName)}`, {
      content,
    });
  }
}
